import { Flexbox } from '@components/styles/mixins/Flexbox.styled';
import styled from 'styled-components';

export const SContactLink = styled.article`
text-decoration:none;
${Flexbox({justifyContent:"flex-start", alignItems:"flex-start", flexDirection:"column"})};
font-size:1.2rem;
.contact-header{
    font-weight:${({ theme }) => theme.fontWeights.regular};
    margin-bottom:1rem;
    color:${({ theme }) => theme.colors.emerald30};
}
.contact-detail{
    width:100%;
    ${Flexbox({justifyContent:"flex-start", alignItems:"center", flexDirection:"row"})};
    cursor:pointer;
    background:${({ theme }) => theme.colors.emerald10};
    border-radius:1.3rem;
    color:${({ theme }) => theme.colors.emerald30};
    padding:1.3rem;
    text-decoration:none;
    column-gap:1rem;
    .icon-container{
        ${Flexbox({justifyContent:"flex-start", alignItems:"center", flexDirection:"row"})};
        img{
            height:2rem
        }
    }
    .contact-address{
        text-decoration:none;
        color:${({ theme }) => theme.colors.emerald30};
        font-size:1.2rem;
    }
}
`;

